import { message } from 'ant-design-vue'
import request, { IPage, IMediaPage, IWorkspaceResponse } from '/@/api/http/request'
const HTTP_PREFIX = '/media/api/v1'

/** 文件夹地图加载列表 */
export const getMapMediaFiles = async function () {
  const url = `${HTTP_PREFIX}/files/folder/map-load-list`
  const result = await request.post(url)
  return result.data
}

// Get Media Files
export const getMediaFiles = async function (wid: string, pagination: IPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/${wid}/files?page=${pagination.page}&page_size=${pagination.page_size}`
  const result = await request.get(url)
  return result.data
}

// Get Media Files
export const getMediaFilesPage = async function (wid: string, pagination: IPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/${wid}/files-page`
  const result = await request.post(url, pagination)
  return result.data
}

export const getMediaFilesPage2 = async function (wid: string, pagination: IMediaPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/${wid}/files-page`
  const result = await request.post(url, pagination)
  return result.data
}

// Download Media File
export const downloadMediaFile = async function (workspaceId: string, fileId: string): Promise<any> {
  const url = `${HTTP_PREFIX}/files/${workspaceId}/file/${fileId}/url`
  const result = await request.get(url, { responseType: 'blob' })
  if (result.data.type === 'application/json') {
    const reader = new FileReader()
    reader.onload = function (e) {
      const text = reader.result as string
      const result = JSON.parse(text)
      message.error(result.message)
    }
    reader.readAsText(result.data, 'utf-8')
  } else {
    return result.data
  }
}

export const downloadWatermarkMediaFile = async function (fileId: string): Promise<any> {
  const url = `/media/api/v1/files/file/export-image/${fileId}`
  const result = await request.get(url, { responseType: 'blob' })
  if (result.data.type === 'application/json') {
    const reader = new FileReader()
    reader.onload = function (e) {
      const text = reader.result as string
      const result = JSON.parse(text)
      message.error(result.message)
    }
    reader.readAsText(result.data, 'utf-8')
  } else {
    return result.data
  }
}

export const downloadZip = async function (body: {}) {
  const url = `${HTTP_PREFIX}/files/file-export`
  const response = await request.post(url, body, { responseType: 'blob' })
  return response
}

// 文件夹分页查询
export interface folderQueryParam {
  start_time: string // 开始时间
  end_time: string // 结束时间
  folder_name: string // 文件夹名称
}

export interface folderPageRequest {
    page: number
    page_size: number
    param: folderQueryParam
}

export interface folderParam {
  folder_id: string
  folder_name : string // 文件夹名称
  create_time : string // 创建时间
  drone: string // 无设备SN
  payload: string // 无设备负载
}

/**
 * 分页接口
 * @param
 * @returns
 */
export const getFolderPage = async function (workspace_id: string, body: folderPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/${workspace_id}/folder-page`
  const result = await request.post(url, body)
  return result.data
}

// 文件夹子集分页查询
export interface subsetQueryParam {
  start_time: string // 开始时间
  end_time: string // 结束时间
  folder_name: string // 文件夹名称
  media_type: string // 媒体类型
}

export interface subsetPageRequest {
    page: number
    page_size: number
    param: folderQueryParam
}

export interface subsetParam {
  id: any
  folder_id : string // 文件夹ID
  folder_name : string // 文件夹名称
  drone: string // 设备SN
  payload: string // 设备负载
  create_time : string // 创建时间
  url: string // 文件
  file_type: string
  name: string,
  lon: string,
  lat: string
  panorama: string,
  file_id: string
}

export interface folderUpdateStatusParams{
  'favorites'?: 0|1,
  'share'?: 0|1,
  'type': 'file'|'folder',
  'id': number,
  'map_load'?: 0|1,
  'name'?: string,
  'parent_id'?: string
}
/**
 * 分页接口
 * @param
 * @returns
 */
export const getSubsetPage = async function (workspace_id: string, folder_id: string, body: subsetPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/${workspace_id}/list-folder-child/${folder_id}`
  const result = await request.post(url, body)
  return result.data
}

// 文件夹下载
export const getFolderDownload = async function (folder_id: string) {
  const url = `${HTTP_PREFIX}/files/folder/download/${folder_id}`
  const result = await request.get(url, { responseType: 'blob' })
  return result
}

// 文件夹下载
export const getNewFolderDownload = async function (body) {
  const url = `${HTTP_PREFIX}/files/folder/download-new`
  const result = await request.post(url, body, { responseType: 'blob' })
  return result
}

/** 更新状态-收藏，分享，是否地图显示 */
export const updateMediaStatus = async function (data:folderUpdateStatusParams) {
  const url = `${HTTP_PREFIX}/files/update-status`
  const result = await request.post(url, data)
  return result.data
}

/** 图片合成 */
export const getImageSynthesis = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/media/api/v1/image-stitch/stitch'
  const result = await request.post(url, body)
  return result.data
}

export interface synthesisQueryParam {
  start_time: string // 开始时间
  end_time: string // 结束时间
  folder_name: string // 文件夹名称
  media_type: string // 媒体类型
}

export interface synthesisPageRequest {
    page: number
    page_size: number
    param: folderQueryParam
}

/** 图片合成分页 */
export const getImageSynthesisPage = async function (body: synthesisPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = '/media/api/v1/image-stitch/page'
  const result = await request.post(url, body)
  return result.data
}

// 文件夹列表
export const getFolderList = async function (workspace_id: any): Promise<IWorkspaceResponse<any>> {
  const url = `/media/api/v1/files/${workspace_id}/folder-list`
  const result = await request.get(url)
  return result.data
}

// 新建文件夹
export const getCreateNewFolder = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/media/api/v1/files/save-folder'
  const result = await request.post(url, body)
  return result.data
}

// 文件移动
export const getRemoveFolder = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/media/api/v1/files/move-file'
  const result = await request.post(url, body)
  return result.data
}
